import { createAction } from 'deox';
import { ResponseErrors } from 'types';

export const getDashboardInfo = {
  request: createAction('dashboard/GET_DASHBOARD_INFO'),
  success: createAction('dashboard/GET_DASHBOARD_INFO_SUCCESS', resolve => (payload: any) =>
    resolve(payload),
  ),
  fail: createAction('dashboard/GET_DASHBOARD_INFO_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const getMachines = {
  request: createAction('dashboard/GET_MACHINES'),
  success: createAction('dashboard/GET_MACHINES_SUCCESS', resolve => (payload: any) =>
    resolve(payload),
  ),
  fail: createAction('dashboard/GET_MACHINES_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const activateMachine = {
  request: createAction('dashboard/ACTIVATE_MACHINE', resolve => (id: number, machineId: string) =>
    resolve({ id, machineId }),
  ),
  success: createAction('dashboard/ACTIVATE_MACHINE_SUCCESS'),
  fail: createAction('dashboard/ACTIVATE_MACHINE_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const deactivateMachine = {
  request: createAction('dashboard/DEACTIVATE_MACHINE', resolve => (id: number) => resolve(id)),
  success: createAction('dashboard/DEACTIVATE_MACHINE_SUCCESS'),
  fail: createAction('dashboard/DEACTIVATE_MACHINE_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const renameMachine = {
  request: createAction('dashboard/RENAME_MACHINE', resolve => (id: number, nickname: string) =>
    resolve({ id, nickname }),
  ),
  success: createAction('dashboard/RENAME_MACHINE_SUCCESS'),
  fail: createAction('dashboard/RENAME_MACHINE_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const getOwnerInfo = {
  request: createAction('dashboard/GET_OWNER_INFO'),
  success: createAction('dashboard/GET_OWNER_INFO_SUCCESS', resolve => (payload: any) =>
    resolve(payload),
  ),
  fail: createAction('dashboard/GET_OWNER_INFO_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};
